<template>
	<Popup
		v-model="selfDisplay"
		title="添加积分商品"
		confirmBtnText="新增"
		@confirmClick="handleAddClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>训练产品</span>
				<el-select v-model="productId" placeholder="请选择" style="width: 100%;">
					<el-option v-for="v in iAssistantIntegralProduct" :key="v.id" :value="v.id" :label="v.label"></el-option>
				</el-select>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="productTip"><i class="b_icon"></i>请选择训练产品</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>积分</span>
				<el-input v-model="integral" placeholder="积分"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="integralTip"><i class="b_icon"></i>请输入积分</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>图标</span>
				<div v-if="!icon" class="b_upload b_inline_block">
					<el-button type="primary">点击上传</el-button>
					<input type="file" accept="image/*" @change="handleIconUpload"/>
					<span class="b_upload_tip">请上传jpg或者png图片！！！</span>
				</div>
				<div v-if="icon" class="b_upload b_inline_block" style="border: 1px solid #ccc;">
					<img :src="icon" alt="" style="">
					<i @click="handleIconDelete"></i>
				</div>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="iconTip"><i class="b_icon"></i>请上传图标</template></div>
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../../../api/index.js';
	import { mapState } from 'vuex';
	import BaseMethods from '../../../../../../../assets/js/base.js';
	
	export default{
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return{
				loading: false,
				selfDisplay: false,
				
				productId: '',
				integral: '',
				icon: '',
				productTip: false,
				integralTip: false,
				iconTip: false
			}
		},
		computed: {
			...mapState([
				'iAssistantIntegralProduct'
			])
		},
		methods: {
			// 点击新增
			handleAddClick() {
				if (!this.productId) {
					this.productTip = true;
					return false;
				} else {
					this.productTip = false;
				}
				if (!this.positiveReg.test(this.integral)) {
					this.integralTip = true;
					return false;
				} else {
					this.integralTip = false;
				}
				if (!this.icon) {
					this.iconTip = true;
					return false;
				} else {
					this.iconTip = false;
				}
				this.add();
			},
			// 新增
			add() {
				const that = this;
				that.loading = true;
				let requestData = {
					pointsCost: that.integral,
					productId: that.productId,
					productIcon: that.icon
				};
				Api.addIAssistantIntegralExchange(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.selfDisplay = false;
						that.$emit('onSuccess');
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			
			// 上传图标
			handleIconUpload(e) {
				const that = this;
				BaseMethods.uploadMultiImg(e, (base64, imgs_type, imgs_name) => {
					that.uploadIcon(base64[0], imgs_type[0], imgs_name[0]);
				}, (msg) => {
					that.$message.error(msg);
				});
			},
			// 删除上传的图标
			handleIconDelete() {
				this.icon = '';
			},
			// 上传图标
			uploadIcon(base64, img_type, fileName) {
				const that = this;
				that.loading = true;
				let iconName = `${ new Date().getTime() }_${ fileName }`;
				let requestData = {
					base: base64,
					picName: iconName,
					type: 'uGateWayUrl'
				};
				Api.uploadPic(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.icon = res.data.data.imgUrl.split('?')[0];
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (!newVal) {
					this.loading = false;
					this.productId = '';
					this.integral = '';
					this.icon = '';
					this.productTip = false;
					this.integralTip = false;
					this.iconTip = false;
				}
			}
		}
	}
</script>

<style>
</style>
